import {useContext} from 'react'

import {Button, Text} from '@primer/react-brand'

import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import {Section} from '../../../../../brand/components/BrandPage'
import type {GenericGroup, GenericContent, GenericSectionWithIds} from '../../../../../brand/lib/types/contentful'

import {PlanTypeContext} from '../../_context/PlanTypeContext'

import {PlanTypeSegmentedControl} from '../../_components/PlanTypeSegmentedControl'
import {PricingPlans} from '../../_components/PricingPlans/PricingPlans'
import IdeList from '../../_components/IdeList'

import styles from './PricingSection.module.css'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function PricingSection(props: Props) {
  const {contentfulContent} = props

  const {sectionIntro} = contentfulContent.fields

  const {featuresCopilotPlanTypes, featuresCopilotPricingOptions, featuresCopilotPricingSectionIdeList} =
    contentfulContent.ids as {
      featuresCopilotPlanTypes: GenericContent
      featuresCopilotPricingOptions: GenericGroup
      featuresCopilotPricingSectionIdeList: GenericContent
    }

  const ideListCtaLink = featuresCopilotPricingSectionIdeList.fields.links?.at(0)

  const {planType, setPlanType} = useContext(PlanTypeContext)

  return (
    <Section id="pricing" introComponent={sectionIntro} introClassName={styles.sectionIntro} withBorder>
      {featuresCopilotPlanTypes ? (
        <div className="d-flex flex-justify-center px-2 mb-7">
          <PlanTypeSegmentedControl
            value={planType}
            onChange={setPlanType}
            contentfulContent={featuresCopilotPlanTypes}
          />
        </div>
      ) : null}

      {featuresCopilotPricingOptions ? <PricingPlans contentfulContent={featuresCopilotPricingOptions} /> : null}

      {featuresCopilotPricingSectionIdeList ? (
        <div>
          <Text as="p" size="200" variant="muted" weight="normal" align="center" className="mb-5">
            {featuresCopilotPricingSectionIdeList.fields.heading}
          </Text>

          <IdeList type="small" location="pricing-cards" />

          {ideListCtaLink ? (
            <div className="d-flex flex-justify-center mt-7">
              <Button
                as="a"
                href={ideListCtaLink.fields.href}
                size="medium"
                hasArrow={false}
                variant="subtle"
                {...getAnalyticsEvent({
                  action: ideListCtaLink.fields.text,
                  tag: 'button',
                  context: 'ide_list',
                  location: 'cta',
                })}
              >
                {ideListCtaLink.fields.text}
              </Button>
            </div>
          ) : null}
        </div>
      ) : null}
    </Section>
  )
}

export default PricingSection

try{ PricingSection.displayName ||= 'PricingSection' } catch {}